module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/141.93eefb4c.png";